import React from "react";
import Navigation from "./navigation";
import NavInfoGeneral from "./navInfoGeneral";
import { useNavigate } from "react-router-dom";
import docTypes from "./docTypes";
import vidTypes from "./vidTypes";

const Help = () => {
    const navigate = useNavigate();
    const handleClick = (event, path) => {
        if (event.metaKey || event.ctrlKey) {        
            // Open in a new tab
            window.open(`/${path}`, '_blank');
        } else {
            // Navigate in the same tab
            navigate(`/${path}`);
        }
    }
    
    const dockerIcon = (
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" color="currentColor" width="20" height="20" viewBox="0 0 640 512">
            <path color="currentColor" d="M349.9 236.3h-66.1v-59.4h66.1v59.4zm0-204.3h-66.1v60.7h66.1V32zm78.2 144.8H362v59.4h66.1v-59.4zm-156.3-72.1h-66.1v60.1h66.1v-60.1zm78.1 0h-66.1v60.1h66.1v-60.1zm276.8 100c-14.4-9.7-47.6-13.2-73.1-8.4-3.3-24-16.7-44.9-41.1-63.7l-14-9.3-9.3 14c-18.4 27.8-23.4 73.6-3.7 103.8-8.7 4.7-25.8 11.1-48.4 10.7H2.4c-8.7 50.8 5.8 116.8 44 162.1 37.1 43.9 92.7 66.2 165.4 66.2 157.4 0 273.9-72.5 328.4-204.2 21.4 .4 67.6 .1 91.3-45.2 1.5-2.5 6.6-13.2 8.5-17.1l-13.3-8.9zm-511.1-27.9h-66v59.4h66.1v-59.4zm78.1 0h-66.1v59.4h66.1v-59.4zm78.1 0h-66.1v59.4h66.1v-59.4zm-78.1-72.1h-66.1v60.1h66.1v-60.1z"/>
        </svg>
    )

    const programmingIcon = (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
            <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0M9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1M6.646 7.646a.5.5 0 1 1 .708.708L5.707 10l1.647 1.646a.5.5 0 0 1-.708.708l-2-2a.5.5 0 0 1 0-.708zm2.708 0 2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L10.293 10 8.646 8.354a.5.5 0 1 1 .708-.708"/>
        </svg>
    )

    const lambdaIcon = (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
            <path d="M11.251.068a.5.5 0 0 1 .227.58L9.677 6.5H13a.5.5 0 0 1 .364.843l-8 8.5a.5.5 0 0 1-.842-.49L6.323 9.5H3a.5.5 0 0 1-.364-.843l8-8.5a.5.5 0 0 1 .615-.09z"/>
        </svg>
    )

    const demo = (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
            <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0M9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1M6.354 9.854a.5.5 0 0 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 8.707V12.5a.5.5 0 0 1-1 0V8.707z"/>
        </svg>
    )

    const privacy = (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
            <path d="M8.188 10H7V6.5h1.188a1.75 1.75 0 1 1 0 3.5"/>
            <path d="M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m5.5 1.5v2a1 1 0 0 0 1 1h2zM7 5.5a1 1 0 0 0-1 1V13a.5.5 0 0 0 1 0v-2h1.188a2.75 2.75 0 0 0 0-5.5z"/>
        </svg>
    )

    const terms = (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
            <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0M9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1M5.057 6h5.886L11 8h-.5c-.18-1.096-.356-1.192-1.694-1.235l-.298-.01v5.09c0 .47.1.582.903.655v.5H6.59v-.5c.799-.073.898-.184.898-.654V6.755l-.293.01C5.856 6.808 5.68 6.905 5.5 8H5z"/>
        </svg>
    )

    const research = (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
            <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0M9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1m.5 10v-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5m-2.5.5a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5zm-3 0a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5z"/>
        </svg>
    )

    const poll = (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
            <path d="M3.05 3.05a7 7 0 0 0 0 9.9.5.5 0 0 1-.707.707 8 8 0 0 1 0-11.314.5.5 0 0 1 .707.707m2.122 2.122a4 4 0 0 0 0 5.656.5.5 0 1 1-.708.708 5 5 0 0 1 0-7.072.5.5 0 0 1 .708.708m5.656-.708a.5.5 0 0 1 .708 0 5 5 0 0 1 0 7.072.5.5 0 1 1-.708-.708 4 4 0 0 0 0-5.656.5.5 0 0 1 0-.708m2.122-2.12a.5.5 0 0 1 .707 0 8 8 0 0 1 0 11.313.5.5 0 0 1-.707-.707 7 7 0 0 0 0-9.9.5.5 0 0 1 0-.707zM10 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0"/>
        </svg>
    )

    const person = (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
            <path d="M8 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"/>
            <path d="m5.93 6.704-.846 8.451a.768.768 0 0 0 1.523.203l.81-4.865a.59.59 0 0 1 1.165 0l.81 4.865a.768.768 0 0 0 1.523-.203l-.845-8.451A1.5 1.5 0 0 1 10.5 5.5L13 2.284a.796.796 0 0 0-1.239-.998L9.634 3.84a.7.7 0 0 1-.33.235c-.23.074-.665.176-1.304.176-.64 0-1.074-.102-1.305-.176a.7.7 0 0 1-.329-.235L4.239 1.286a.796.796 0 0 0-1.24.998l2.5 3.216c.317.316.475.758.43 1.204Z"/>
        </svg>
    )

    const zip = (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
            <path d="M5.5 9.438V8.5h1v.938a1 1 0 0 0 .03.243l.4 1.598-.93.62-.93-.62.4-1.598a1 1 0 0 0 .03-.243"/>
            <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0M9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1m-4-.5V2h-1V1H6v1h1v1H6v1h1v1H6v1h1v1H5.5V6h-1V5h1V4h-1V3zm0 4.5h1a1 1 0 0 1 1 1v.938l.4 1.599a1 1 0 0 1-.416 1.074l-.93.62a1 1 0 0 1-1.109 0l-.93-.62a1 1 0 0 1-.415-1.074l.4-1.599V8.5a1 1 0 0 1 1-1"/>
        </svg>
    )

    return (
        <>
            <Navigation help={true} info={<NavInfoGeneral title={"Help"} text={"See documentation, tutorials, helpful information, and more to the right."}/>}/>
            <div className="autograder-container">
                <div className="autograder-documentation" style={{ rowGap: "20px" }}>
                    <div className="help-container">
                        <span style={{ fontWeight: "500", fontSize: "var(--font-size-two)" }}>
                            Tutorials & Demonstrations (2-3 minutes each):
                        </span>
                        <div className="help-item" onClick={(e) => {
                            handleClick(e, "videos/" + vidTypes.POLL_MODE);
                        }}>                            
                            {poll}
                            Poll Mode Tutorial
                        </div>
                        <div className="help-item" onClick={(e) => {
                            handleClick(e, "videos/" + vidTypes.DOCKERFILE);
                        }}>                            
                            {dockerIcon}
                            Dockerfile Tutorial
                        </div>
                        <div className="help-item" onClick={(e) => {
                            handleClick(e, "videos/" + vidTypes.PROGRAMMING);
                        }}>                            
                            {programmingIcon}
                            Programming Questions Tutorial
                        </div>
                        <div className="help-item" onClick={(e) => {
                            handleClick(e, "videos/" + vidTypes.ZIP_FILE);
                        }}>                            
                            {zip}
                            Programming Zip File Tutorial
                        </div>                        
                        <div className="help-item" onClick={(e) => {
                            handleClick(e, "videos/" + vidTypes.LAMBDA);
                        }}>                            
                            {lambdaIcon}
                            Lambda Tutorial
                        </div>                        
                        <div className="help-item" onClick={(e) => {
                            handleClick(e, "videos/" + vidTypes.LOGS);
                        }}>                            
                            {research}
                            Code Logs Tutorial
                        </div>
                        <div className="help-item" onClick={(e) => {
                            handleClick(e, "videos/" + vidTypes.DEMO);
                        }}>                            
                            {demo}
                            Quick Demo
                        </div>
                    </div>
                    <div className="help-container">
                        <span style={{ fontWeight: "500", fontSize: "var(--font-size-two)" }}>
                            Ask Questions:
                        </span>
                        <div className="help-item" onClick={(e) => {
                            handleClick(e, "account-settings#support");
                        }}>                            
                            {person}
                            Support Form
                        </div>
                    </div>
                    <div className="help-container">
                        <span style={{ fontWeight: "500", fontSize: "var(--font-size-two)" }}>
                            Documentation:
                        </span>
                        <div className="help-item" onClick={(e) => {
                            handleClick(e, "docs/" + docTypes.DOCKER);
                        }}>                            
                            {dockerIcon}
                            Dockerfile Docs
                        </div>
                        <div className="help-item" onClick={(e) => {
                            handleClick(e, "docs/" + docTypes.PROGRAMMING);
                        }}>
                            {programmingIcon}
                            Programming Autograder Docs
                        </div>
                        <div className="help-item" onClick={(e) => {
                            handleClick(e, "docs/" + docTypes.LAMBDA);
                        }}>
                            {lambdaIcon}
                            Lambda Autograder Docs
                        </div>
                        <div className="help-item" onClick={(e) => {
                            handleClick(e, "docs/" + docTypes.LOGS);
                        }}>
                            {research}
                            Research Code Logs Docs
                        </div>
                    </div>
                    <div className="help-container">
                        <span style={{ fontWeight: "500", fontSize: "var(--font-size-two)" }}>
                            Documents:
                        </span>
                        <div className="help-item" onClick={(e) => {
                            handleClick(e, "privacy-policy");
                        }}>                            
                            {privacy}
                            Privacy Policy
                        </div>
                        <div className="help-item" onClick={(e) => {
                            handleClick(e, "terms-and-conditions");
                        }}>                            
                            {terms}
                            Terms & Conditions
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Help;